###
# When 'display' changes to a truthy value we open the modal. Then we wait for our
# 'dependencies' (promises) to resolve. The user is then able to select
# submit or cancel.
#
# display:                    (bool) Show/Hide the modal.
# readOnly:                   (bool) Indicator to show dependencies in read-only mode (no selection/confirm button).
# dependencies:               (object) A map of resource id(s) to a promise for resolving its dependencies.
# resourceType:               (object) The type of resource we are trying to resolve dependencies for.
# resourceNames:              (object) A map of resource id(s) to a resource name. This should contain the same resource id(s) as 'dependencies'.
# confirmCallback:            (function) A callback function to call upon the confirm button being clicked.
#                                       the callback signature is function(user-choices), where user-choices is a map of resource id(s)
#                                       to an object that contains {selected: true/false}.
# confirmMessage (optional):  (string) A message to show next to the confirmation button
#
# Example:
#  <resource-dependencies
#   display="bool"
#   read-only="bool"
#   dependencies="map_from_resourceId_to_dependency_promises"
#   resource-type="resource_type"
#   resource-names="map_from_resourceId_to_resourceName"
#   confirm-callback="function"
#   confirm-message="message_string">
#  </resource-dependencies>
###
angular.module('rjmNg.directives').directive "resourceDependencies", [
  () ->
    restrict: 'E'
    templateUrl: "modal.resourceDependencies.html"
    scope:
      display: '='
      readOnly: '='
      dependencies: '='
      resourceType: '='
      resourceNames: '='
      confirmCallback: '='
      confirmMessage: '='
    bindToController: true
    controllerAs: "view"
    controller: [
      "$q"
      "dependencyEnums"
      ($q, dependencyEnums) ->
        view = @
        view.loading = false
        view.error = false
        view.resourceDependencies = []
        view.dependencyTypes = dependencyEnums.RESOURCE_DEPENDENCIES
        view.userChoices = {}
        view.getKeys = Object.keys
        view.noneAreSelected = false

        view.init = ->
          view.userChoices = angular.copy(view.resourceNames)
          for uc of view.userChoices
            view.userChoices[uc].selected = true 
            view.userChoices[uc].hasDependencies = false

        view.resolveDependencies = ->
          $q.all(view.dependencies).then(
            (responses) ->
              view.loading = false
              view.resourceDependencies = responses 
              view.hasDependencies = false

              for key, response of responses
                respDep = _.some(Object.keys(response), (val) -> view.dependencyTypes[val])
                if(respDep)
                  view.userChoices[key].selected = false
                  view.userChoices[key].hasDependencies = true
                  view.hasDependencies = true

              view.watchForUnselect()

            , (error) ->
              view.loading = false
              view.error = true
          )

        view.cancel = ->
          view.display = false

        view.confirm = ->
          view.display = false
          view.confirmCallback(view.userChoices)

        view.watchForUnselect = ->
          view.noneAreSelected = true
          angular.forEach(view.userChoices, (userChoice) ->
            if userChoice.selected
              view.noneAreSelected = false
              return
          )

        return view
    ]
    link: (scope, el, attrs, ctrl) ->
      scope.$watch 'view.display', (newVal, oldVal) ->
        if newVal? and newVal
          $('#dependencyModal').modal()
          ctrl.init()
          ctrl.resolveDependencies()
          scope.view.loading = true
        else
          $('#dependencyModal').modal('hide')
          scope.view.loading = false
  ]
